import { createSlice } from "@reduxjs/toolkit"
import { ApiStatus } from "../../types/api/status"
import { AccountReceivable, accountReceivableType } from "../../types/slices/accountReceivableType"
import { RootState } from "../store"

const initialState: accountReceivableType = {
    status: ApiStatus.FETCHED,
    accounts: [],
    totalRows: 0,
    accountSelected: {} as AccountReceivable,
    errorMessage: undefined
}

const accountReceivableSlice = createSlice({
    name: 'accountReceivableSlice',
    initialState,
    reducers: {
        onFetchAccountReceivables(state, { payload }: { payload: AccountReceivable[] }) {
            state.status = ApiStatus.FETCHED
            state.accounts = payload
            state.errorMessage = undefined
        },
        onSetSelectedAccountReceivable(state, { payload }: { payload: AccountReceivable }) {
            state.accountSelected = payload
        },
        changeStatus(state, { payload }: { payload: ApiStatus }) {

            state.status = payload
        },
        onFetchTotalRows(state, { payload }: { payload: number }) {
            state.totalRows = payload
        }
    }
})

export const selectAccountReceivableState = (state: RootState) => state.accountReceivableSlice
export default accountReceivableSlice.reducer
export const {
    onFetchAccountReceivables,
    onSetSelectedAccountReceivable,
    changeStatus,
    onFetchTotalRows
} = accountReceivableSlice.actions